import { UniteTypePaymentMethod } from '~/generated/payoutBackend/model';

export const paymentMethods = Object.values(UniteTypePaymentMethod)
    .filter((c) => c !== UniteTypePaymentMethod.METHOD_UNSPECIFIED)
    .map((value) => ({
        value,
        label: value.replace('METHOD_', '').replaceAll('_', ''),
    }));
